<template>
  <section class="hero-section" aria-label="首页首屏">
    <div class="hero-bg"></div>
    <div class="hero-overlay"></div>
    <div class="hero-container">
      <div class="hero-text">
        <div class="hero-kicker">匠心致诚（武汉）技术服务有限公司</div>
        <h1 class="hero-title">匠心制造<span class="title-separator">·</span>极致诚信</h1>
        <p class="hero-description">
          专注数控加工设备管理保障服务与设备工程服务，为客户提供从维修、保养到改造、搬迁的一站式解决方案。
        </p>

        <div class="hero-actions">
          <a class="primary-btn" href="#business" @click.prevent="scrollTo('business')">查看核心业务</a>
          <a class="ghost-btn" href="#contact" @click.prevent="scrollTo('contact')">联系获取方案</a>
        </div>
      </div>

      <div class="hero-showcase" aria-hidden="true">
        <div class="showcase-grid">
          <div class="showcase-img img-1">
            <ZoomableImage :src="showcaseImgs[0]" alt="设备改造案例现场" fit="cover" />
          </div>
          <div class="showcase-img img-2">
            <ZoomableImage :src="showcaseImgs[1]" alt="稳定性提升改造现场" fit="cover" />
          </div>
          <div class="showcase-img img-3">
            <ZoomableImage :src="showcaseImgs[2]" alt="设备核心部件细节" fit="cover" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ZoomableImage from './ZoomableImage.vue';

export default {
  name: 'HeroSection',
  components: {
    ZoomableImage
  },
  data() {
    return {
      // 使用不在其它板块重复出现的代表性图片
      showcaseImgs: [
        require('@/assets/images/business/image27.png'),
        require('@/assets/images/gallery/stability-system.jpg'),
        require('@/assets/images/business/image19.png')
      ]
    };
  },
  methods: {
    scrollTo(id) {
      const el = document.getElementById(id);
      if (!el) return;
      const navbarHeight = 80;
      const top = el.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }
};
</script>

<style scoped>
/* 英雄区容器 */
.hero-section {
  position: relative;
  width: 100%;
  height: 420px;
  margin-top: 80px;     /* 为固定导航栏留出空间 */
  overflow: hidden;
}

/* 背景图片：覆盖整个英雄区，居中裁剪 */
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/images/business/image8.png');
  background-size: cover;
  background-position: center 40%;
  background-repeat: no-repeat;
}

/* 暗色遮罩：提高文字可读性 */
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.25) 100%);
}

/* 内容容器：最大宽度1200px，水平居中 */
.hero-container {
  position: relative;
  z-index: 2;
  max-width: 1200px;
  height: 100%;
  margin: 0 auto;
  padding: 56px 20px 0 20px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 48px;
}

.hero-text {
  max-width: 640px;
}

.hero-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.95rem;
  letter-spacing: 1px;
  margin-bottom: 16px;
}

/* 标题样式：增加文字阴影和字间距，提升质感 */
.hero-title {
  font-size: 3.2rem;
  font-weight: bold;
  line-height: 1.3;
  color: #ffffff;
  margin: 0 0 12px 0;
  letter-spacing: 5px;           /* 增加字间距，更显大气 */
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);  /* 文字阴影，增强立体感 */
}

/* 标题中的分隔符样式 */
.title-separator {
  margin: 0 8px;
  color: #64b5f6;
}

/* 描述文字样式 */
.hero-description {
  font-size: 1.05rem;
  font-weight: 500;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.9);
  margin: 0;
  letter-spacing: 1px;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
}

.hero-actions {
  display: flex;
  gap: 14px;
  margin-top: 22px;
}

.primary-btn,
.ghost-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  padding: 0 18px;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 700;
  letter-spacing: 1px;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.2s ease;
}

.primary-btn {
  background: #1976d2;
  color: #ffffff;
  box-shadow: 0 10px 28px rgba(25, 118, 210, 0.35);
}

.primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 36px rgba(25, 118, 210, 0.45);
}

.ghost-btn {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: rgba(255, 255, 255, 0.92);
}

.ghost-btn:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.38);
}

.hero-showcase {
  flex: 1;
  max-width: 460px;
  margin-top: 6px;
}

.showcase-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 160px 160px;
  gap: 14px;
}

.showcase-img {
  border-radius: 16px;
  overflow: hidden;
  background-size: cover;
  background-position: center;
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
}

.showcase-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.img-1 {
  grid-column: 1 / 2;
  grid-row: 1 / 3;
}

.img-2 {
  grid-column: 2 / 3;
  grid-row: 1 / 2;
}

.img-3 {
  grid-column: 2 / 3;
  grid-row: 2 / 3;
}

/* ============================================================
   响应式样式：平板电脑（宽度小于1024px）
   ============================================================ */
@media (max-width: 1024px) {
  .hero-container {
    padding-top: 44px;
    gap: 26px;
  }
  
  .hero-title {
    font-size: 2.5rem;
    letter-spacing: 3px;
      margin: 0 0 12px 0;
  }

  .hero-showcase {
    max-width: 360px;
  }

  .showcase-grid {
    grid-template-rows: 140px 140px;
  }
}

/* ============================================================
   响应式样式：手机端（宽度小于768px）
   移动端背景图高度通过调整 .hero-section 的 height 来控制
   ============================================================ */
@media (max-width: 768px) {
  .hero-section {
    height: auto;
    min-height: 420px;
    margin-top: 60px;
  }
  
  .hero-bg {
    background-image: url('@/assets/images/business/image8.png');
    background-position: center 40%;
  }
  
  .hero-container {
    padding: 28px 18px 26px 18px;
    flex-direction: column;
    gap: 18px;
  }
  
  .hero-title {
    font-size: 1.8rem;
    letter-spacing: 2px;
    margin-bottom: 0;
    margin: 0 0 12px 0;
  }
  
  .hero-description {
    font-size: 0.95rem;
    letter-spacing: 0.5px;
  }
  
  .title-separator {
    margin: 0 4px;
  }

  .hero-actions {
    flex-direction: column;
    align-items: flex-start;
  }

  .primary-btn,
  .ghost-btn {
    width: 100%;
  }

  .hero-showcase {
    width: 100%;
    max-width: none;
    margin-top: 6px;
  }

  .showcase-grid {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 120px;
  }

  .img-1 {
    grid-column: 1 / 2;
    grid-row: 1 / 2;
  }
  .img-2 {
    grid-column: 2 / 3;
    grid-row: 1 / 2;
  }
  .img-3 {
    grid-column: 3 / 4;
    grid-row: 1 / 2;
  }
}
</style>